export const headerId = "custom-header-v1";
export const headerSearchBarId = "header-search-bar";
export const headerSignInId = "header-sign-in";
export const headerCartId = "header-cart";
export const headerProfileId = "header-profile";
export const headerPhoneId = "header-phone";
export const headerLogoId = "header-main-logo";
export const headerHamburgerId = "header-hamburger";

export const headerLayoutComponents = [
	{
		name: "Centered Navigation Header",
		key: "centered-navigation",
		media: `
  <header class="py-2 px-4 border border-blue-500" style="zoom: 0.1;">
      <div class="flex justify-between items-center p-1 border border-blue-500">
          <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
          <nav class="flex gap-4 p-1 border border-blue-500">
              <div class="nav-item min-w-[32px] min-h-[24px] border border-blue-500"></div>
              <div class="nav-item min-w-[32px] min-h-[24px] border border-blue-500"></div>
              <div class="nav-item min-w-[32px] min-h-[24px] border border-blue-500"></div>
          </nav>
          <div class="buttons min-w-[56px] min-h-[32px] border border-blue-500"></div>
      </div>
  </header>
      `,
		content: `
  <header id="${headerId}" class="py-2 px-4">
      <div class="flex justify-between items-center p-1">
          <div class="logo min-w-[48px] min-h-[32px]"></div>
          <nav class="flex gap-4 p-1">
              <div class="nav-item min-w-[32px] min-h-[24px]"></div>
              <div class="nav-item min-w-[32px] min-h-[24px]"></div>
              <div class="nav-item min-w-[32px] min-h-[24px]"></div>
          </nav>
          <div class="buttons min-w-[56px] min-h-[32px]"></div>
      </div>
  </header>
      `,
	},
	{
		name: "Vertical Stack Header",
		key: "vertical-stack",
		media: `
  <header class="py-2 px-4 border border-blue-500" style="zoom: 0.1;">
      <div class="flex flex-col gap-2 p-1 border border-blue-500">
          <div class="flex justify-between">
              <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
              <div class="buttons min-w-[56px] min-h-[32px] border border-blue-500"></div>
          </div>
          <div class="w-full min-h-[24px] border border-blue-500"></div>
      </div>
  </header>
      `,
		content: `
  <header id="${headerId}" class="py-2 px-4">
      <div class="flex flex-col gap-2 p-1">
          <div class="flex justify-between">
              <div class="logo min-w-[48px] min-h-[32px]"></div>
              <div class="buttons min-w-[56px] min-h-[32px]"></div>
          </div>
          <div class="w-full min-h-[24px]"></div>
      </div>
  </header>
      `,
	},
	{
		name: "Split Navigation Header",
		key: "split-navigation",
		media: `
  <header class="py-2 px-4 border border-blue-500" style="zoom: 0.1;">
      <div class="flex justify-between items-center p-1 border border-blue-500">
          <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
          <div class="flex gap-4">
              <div class="nav-item min-w-[32px] min-h-[24px] border border-blue-500"></div>
              <div class="nav-item min-w-[32px] min-h-[24px] border border-blue-500"></div>
              <div class="nav-item min-w-[32px] min-h-[24px] border border-blue-500"></div>
          </div>
          <div class="buttons min-w-[56px] min-h-[32px] border border-blue-500"></div>
      </div>
      <div class="border border-blue-500 w-full min-h-[24px] mt-2"></div>
  </header>
      `,
		content: `
  <header id="${headerId}" class="py-2 px-4">
      <div class="flex justify-between items-center p-1">
          <div class="logo min-w-[48px] min-h-[32px]"></div>
          <div class="flex gap-4">
              <div class="nav-item min-w-[32px] min-h-[24px]"></div>
              <div class="nav-item min-w-[32px] min-h-[24px]"></div>
              <div class="nav-item min-w-[32px] min-h-[24px]"></div>
          </div>
          <div class="buttons min-w-[56px] min-h-[32px]"></div>
      </div>
      <div class="w-full min-h-[24px] mt-2"></div>
  </header>
      `,
	},
	{
		name: "Centered Logo Header",
		key: "centered-logo",
		media: `
  <header class="py-2 px-4 border border-blue-500" style="zoom: 0.1;">
      <div class="flex justify-center p-1 border border-blue-500">
          <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
      </div>
      <div class="flex justify-between mt-2">
          <div class="buttons min-w-[56px] min-h-[32px] border border-blue-500"></div>
          <div class="buttons min-w-[56px] min-h-[32px] border border-blue-500"></div>
      </div>
  </header>
      `,
		content: `
  <header id="${headerId}" class="py-2 px-4">
      <div class="flex justify-center p-1">
          <div class="logo min-w-[48px] min-h-[32px]"></div>
      </div>
      <div class="flex justify-between mt-2">
          <div class="buttons min-w-[56px] min-h-[32px]"></div>
          <div class="buttons min-w-[56px] min-h-[32px]"></div>
      </div>
  </header>
      `,
	},
	{
		name: "Icon-Based Header",
		key: "icon-based",
		media: `
  <header class="py-2 px-4 border border-blue-500" style="zoom: 0.1;">
      <div class="flex justify-between items-center p-1 border border-blue-500">
          <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
          <div class="flex gap-3">
              <div class="icon min-w-[24px] min-h-[24px] border border-blue-500 rounded-full"></div>
              <div class="icon min-w-[24px] min-h-[24px] border border-blue-500 rounded-full"></div>
              <div class="icon min-w-[24px] min-h-[24px] border border-blue-500 rounded-full"></div>
          </div>
      </div>
  </header>
      `,
		content: `
  <header id="${headerId}" class="py-2 px-4">
      <div class="flex justify-between items-center p-1">
          <div class="logo min-w-[48px] min-h-[32px]"></div>
          <div class="flex gap-3">
              <div class="icon min-w-[24px] min-h-[24px] rounded-full"></div>
              <div class="icon min-w-[24px] min-h-[24px] rounded-full"></div>
              <div class="icon min-w-[24px] min-h-[24px] rounded-full"></div>
          </div>
      </div>
  </header>
      `,
	},
	{
		name: "Search Bar Header",
		key: "search-bar",
		media: `
  <header class="py-2 px-4 border border-blue-500" style="zoom: 0.1;">
      <div class="flex justify-between items-center p-1 border border-blue-500">
          <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
          <div class="search-bar min-w-[192px] min-h-[32px] border border-blue-500"></div>
          <div class="buttons min-w-[56px] min-h-[32px] border border-blue-500"></div>
      </div>
  </header>
      `,
		content: `
  <header id="${headerId}" class="py-2 px-4">
      <div class="flex justify-between items-center p-1">
          <div class="logo min-w-[48px] min-h-[32px]"></div>
          <div class="search-bar min-w-[192px] min-h-[32px]"></div>
          <div class="buttons min-w-[56px] min-h-[32px]"></div>
      </div>
  </header>
      `,
	},
	{
		name: "Multi-Row Header",
		key: "multi-row",
		media: `
  <header class="py-2 px-4 border border-blue-500" style="zoom: 0.1;">
      <div class="flex justify-between p-1 border border-blue-500 mb-2">
          <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
          <div class="buttons min-w-[56px] min-h-[32px] border border-blue-500"></div>
      </div>
      <div class="flex justify-around p-1 border border-blue-500">
          <div class="nav-item min-w-[48px] min-h-[24px] border border-blue-500"></div>
          <div class="nav-item min-w-[48px] min-h-[24px] border border-blue-500"></div>
          <div class="nav-item min-w-[48px] min-h-[24px] border border-blue-500"></div>
      </div>
  </header>
      `,
		content: `
  <header id="${headerId}" class="py-2 px-4">
      <div class="flex justify-between p-1 mb-2">
          <div class="logo min-w-[48px] min-h-[32px]"></div>
          <div class="buttons min-w-[56px] min-h-[32px]"></div>
      </div>
      <div class="flex justify-around p-1">
          <div class="nav-item min-w-[48px] min-h-[24px]"></div>
          <div class="nav-item min-w-[48px] min-h-[24px]"></div>
          <div class="nav-item min-w-[48px] min-h-[24px]"></div>
      </div>
  </header>
      `,
	},
	{
		name: "Asymmetric Header",
		key: "asymmetric",
		media: `
  <header class="py-2 px-4 border border-blue-500" style="zoom: 0.1;">
      <div class="flex items-center gap-4 p-1 border border-blue-500">
          <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
          <div class="flex-1 min-h-[24px] border border-blue-500"></div>
          <div class="buttons min-w-[56px] min-h-[32px] border border-blue-500"></div>
      </div>
  </header>
      `,
		content: `
  <header id="${headerId}" class="py-2 px-4">
      <div class="flex items-center gap-4 p-1">
          <div class="logo min-w-[48px] min-h-[32px]"></div>
          <div class="flex-1 min-h-[24px]"></div>
          <div class="buttons min-w-[56px] min-h-[32px]"></div>
      </div>
  </header>
      `,
	},
];

export const searchBarComponents = [
	{
		name: "Search Bar 1",
		key: "search-bar-1",
		media: `
        <div class="flex relative rounded-md w-full px-4 max-w-xl" style="zoom: 0.5;">
        <input type="text" name="q" id="query" placeholder="Button, Footer, etc"
            class="w-full p-3 rounded-md border-2 border-r-white rounded-r-none border-gray-300 placeholder-gray-500 dark:placeholder-gray-300 dark:bg-gray-500dark:text-gray-300 dark:border-none " />
        <button
            class="inline-flex items-center gap-2 bg-violet-700 text-white text-lg font-semibold py-3 px-6 rounded-r-md">
            <span>search</span>
            <span class="hidden md:block">
                <svg class="text-gray-200 h-5 w-5 p-0 fill-current" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                    viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 56.966 56.966;" xml:space="preserve"
                    width="512px" height="512px">
                    <path
                        d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                </svg>
            </span>
        </button>
    </div>
        `,
		content: `
        <form id="${headerSearchBarId}" class="flex relative rounded-md w-full px-4 max-w-xl">
            <input type="text" name="q" id="query" placeholder="Button, Footer, etc"
                class="w-full p-3 rounded-md border-2 border-r-white rounded-r-none border-gray-300 placeholder-gray-500 dark:placeholder-gray-300 dark:bg-gray-500dark:text-gray-300 dark:border-none " />
            <button
                type="submit"
                class="inline-flex items-center gap-2 bg-violet-700 text-white text-lg font-semibold py-3 px-6 rounded-r-md">
                <span>search</span>
                <span class="hidden md:block">
                    <svg class="text-gray-200 h-5 w-5 p-0 fill-current" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                        viewBox="0 0 56.966 56.966" style="enable-background:new 0 0 56.966 56.966;" xml:space="preserve"
                        width="512px" height="512px">
                        <path
                            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                    </svg>
                </span>
            </button>
        </form>
        `,
	},
	{
		name: "Search Bar 2",
		key: "search-bar-2",
		content: `
            <div class="flex justify-center sm:justify-start">
                <label class="hidden py-1 px-3" for="bar-search"></label>
                <input class="appearance-none text-md py-1 px-2 focus:outline-none border-2 focus:ring-blue-600 focus:border-blue-600 text-purple-900 placeholder-blue-300 font-semibold rounded-l" type="search" name="q" placeholder="Search" >
                <button type="submit" class="bg-blue-500 hover:bg-blue-800 px-5 py-1 text-lg font-bold hover:shadow-2xl cursor-pointer transition duration-250 ease-in-out rounded-r text-white" value="Search" color="blue">Search</button>
            </div>
        `,
		media: `
            <form id="${headerSearchBarId}" class="flex justify-center sm:justify-start" style="zoom:0.5;">
                <label class="hidden py-1 px-3" for="bar-search"></label>
                <input class="appearance-none text-md py-1 px-2 focus:outline-none border-2 focus:ring-blue-600 focus:border-blue-600 text-purple-900 placeholder-blue-300 font-semibold rounded-l" type="search" name="q" placeholder="Search" >
                <button type="submit" class="bg-blue-500 hover:bg-blue-800 px-5 py-1 text-lg font-bold hover:shadow-2xl cursor-pointer transition duration-250 ease-in-out rounded-r text-white" value="Search" color="blue">Search</button>
            </form>
        `,
	},
	{
		name: "Search Bar 3",
		key: "search-bar-3",
		content: `
            <form id="${headerSearchBarId}"
                class="relative bg-white min-w-sm max-w-2xl flex flex-col md:flex-row items-center justify-center border py-2 px-2 rounded-2xl gap-2 shadow-2xl focus-within:border-gray-300">
                <input id="search-bar" name="q" placeholder="your keyword here"
                    class="px-6 py-2 w-full rounded-md flex-1 outline-none bg-white">
                <button
                    type="submit"
                    class="w-full md:w-auto px-6 py-3 bg-black border-black text-white fill-white active:scale-95 duration-100 border will-change-transform overflow-hidden relative rounded-xl transition-all disabled:opacity-70">
                    
                    <div class="relative">
                        <div class="flex items-center transition-all opacity-1 valid:"><span
                                class="text-sm font-semibold whitespace-nowrap truncate mx-auto">
                                Search
                            </span>
                        </div>

                    </div>
                    
                </button>
            </form>
        `,
		media: `
        <div style="zoom:0.5;"
            class=" relative bg-white min-w-sm max-w-2xl flex flex-col md:flex-row items-center justify-center border py-2 px-2 rounded-2xl gap-2 shadow-2xl focus-within:border-gray-300"
            for="search-bar">
            <input id="search-bar" name="q" placeholder="your keyword here"
                class="px-6 py-2 w-full rounded-md flex-1 outline-none bg-white">
            <button
                class="w-full md:w-auto px-6 py-3 bg-black border-black text-white fill-white active:scale-95 duration-100 border will-change-transform overflow-hidden relative rounded-xl transition-all disabled:opacity-70">
                
                <div class="relative">
                    <div class="flex items-center transition-all opacity-1 valid:"><span
                            class="text-sm font-semibold whitespace-nowrap truncate mx-auto">
                            Search
                        </span>
                    </div>

                </div>
                
            </button>
        </div>
        `,
	},
	{
		name: "Search Bar 4",
		key: "search-bar-4",
		content: `
            <form id="${headerSearchBarId}" class="relative max-w-sm">
                <input name="q" class="w-full py-2 px-4 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type="search" placeholder="Search">
                <button type="submit" class="absolute inset-y-0 right-0 flex items-center px-4 text-gray-700 bg-gray-100 border border-gray-300 rounded-r-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                    <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.795 13.408l5.204 5.204a1 1 0 01-1.414 1.414l-5.204-5.204a7.5 7.5 0 111.414-1.414zM8.5 14A5.5 5.5 0 103 8.5 5.506 5.506 0 008.5 14z" />
                    </svg>
                </button>
            </form>
        `,
		media: `
            <div class="relative max-w-sm" style="zoom:0.5;">
                <input class="w-full py-2 px-4 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" type="search" placeholder="Search">
                <button class="absolute inset-y-0 right-0 flex items-center px-4 text-gray-700 bg-gray-100 border border-gray-300 rounded-r-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                    <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.795 13.408l5.204 5.204a1 1 0 01-1.414 1.414l-5.204-5.204a7.5 7.5 0 111.414-1.414zM8.5 14A5.5 5.5 0 103 8.5 5.506 5.506 0 008.5 14z" />
                    </svg>
                </button>
            </div>
        `,
	},
];

export const headerComponents = [
	{
		name: "Profile",
		key: "profile-button",
		content: `
        <span class="relative inline-block">
            <img src="https://randomuser.me/api/portraits/women/50.jpg" class="object-cover w-16 h-16 rounded-full "/>
            <span class="absolute animate-pulse top-0 right-0 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></span>
        </span>
        `,
		media: `
        <span class="relative inline-block">
            <img src="https://randomuser.me/api/portraits/women/50.jpg" class="object-cover w-16 h-16 rounded-full "/>
            <span class="absolute animate-pulse top-0 right-0 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></span>
        </span>
        `,
	},
	{
		name: "Cart",
		key: "cart-button",
		content: `
        <a href="#" class="relative">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
            </svg>
        </a>
        `,
		media: `
        <a href="#" class="relative">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
            </svg>
            <span class="absolute -top-1 -right-1 w-4 h-4 bg-primary rounded-full text-xs flex items-center justify-center text-white">2</span>
        </a>
        `,
	},
	{
		name: "Sign In",
		key: "sign-in-button",
		content: `
        <a id="${headerSignInId}" href="#" class="bg-blue-500 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
            <svg class="mr-2 -ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
            </svg>
            Sign In
        </a>
        `,
		media: `
        <a href="#" class="bg-blue-500 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
            <svg class="mr-2 -ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
            </svg>
            Sign In
        </a>
        `,
	},
	{
		name: "MainLogo",
		key: "main-logo",
		content: `
        <a id="${headerLogoId}" href="/" class="flex items-center">
            <img src="/api/placeholder/200/50" alt="Company Logo" class="h-10 w-auto" />
        </a>
        `,
		media: `
        <a href="/" class="flex items-center">
            <img src="/api/placeholder/200/50" alt="Company Logo" class="h-10 w-auto" />
        </a>
        `,
	},
	{
		name: "Phone Number",
		key: "phone-number",
		content: `
        <a id="${headerPhoneId}" href="tel:+18001234567" class="flex items-center text-gray-700 hover:text-primary">
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span>(800) 123-4567</span>
        </a>
        `,
		media: `
        <a href="tel:+18001234567" class="flex items-center text-gray-700 hover:text-primary">
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span>(800) 123-4567</span>
        </a>
        `,
	},
	{
		name: "Hamburger Menu",
		key: "hamburger-menu",
		content: `
        <button id="${headerHamburgerId}" class="block text-gray-700 hover:text-primary focus:outline-none">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
        </button>
        `,
		media: `
        <button class="block text-gray-700 hover:text-primary focus:outline-none">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
        </button>
        `,
	},
];

export const socialButtons = [
	{
		name: "Instagram",
		key: "instagram-button",
		content: `
            <button class="relative inline-block w-12 h-12 rounded-full group">
            <div
                class="floater w-full h-full absolute top-0 left-0 bg-violet-400 rounded-full duration-300 group-hover:-top-8 group-hover:shadow-2xl"
            ></div>
            <div
                class="icon relative z-10 w-full h-full flex items-center justify-center border-2 border-violet-400 rounded-full"
            >
                <svg
                fill="none"
                viewBox="0 0 22 22"
                height="22"
                width="22"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M21.94 6.46809C21.8884 5.2991 21.6994 4.49551 21.4285 3.79911C21.1492 3.05994 20.7194 2.39818 20.1564 1.84802C19.6062 1.28932 18.9401 0.855163 18.2094 0.580194C17.5091 0.309437 16.7096 0.120336 15.5407 0.0688497C14.363 0.0128932 13.9891 0 11.0022 0C8.01527 0 7.64141 0.0128932 6.46808 0.064466C5.29914 0.116039 4.49551 0.305225 3.79932 0.57581C3.05994 0.855163 2.39818 1.28494 1.84802 1.84802C1.28932 2.39813 0.855377 3.06428 0.580193 3.7949C0.309437 4.49551 0.120379 5.2948 0.0688496 6.4637C0.0129362 7.64141 0 8.01527 0 11.0022C0 13.9891 0.0129362 14.363 0.0644659 15.5363C0.116039 16.7053 0.305225 17.5089 0.576025 18.2053C0.855377 18.9444 1.28932 19.6062 1.84802 20.1564C2.39818 20.7151 3.06432 21.1492 3.79494 21.4242C4.49547 21.6949 5.29476 21.884 6.46391 21.9355C7.63702 21.9873 8.0111 22 10.998 22C13.9849 22 14.3588 21.9873 15.5321 21.9355C16.7011 21.884 17.5047 21.695 18.2009 21.4242C18.9321 21.1415 19.5961 20.7091 20.1505 20.1548C20.7048 19.6005 21.1373 18.9365 21.42 18.2053C21.6906 17.5047 21.8798 16.7052 21.9314 15.5363C21.9829 14.363 21.9958 13.9891 21.9958 11.0022C21.9958 8.01527 21.9914 7.64137 21.94 6.46809ZM19.9588 15.4503C19.9114 16.5248 19.731 17.105 19.5805 17.4918C19.2109 18.4502 18.4502 19.2109 17.4918 19.5805C17.105 19.731 16.5206 19.9114 15.4503 19.9586C14.29 20.0103 13.942 20.023 11.0066 20.023C8.07118 20.023 7.71881 20.0103 6.56259 19.9586C5.48816 19.9114 4.90796 19.731 4.52117 19.5805C4.04425 19.4043 3.61014 19.1249 3.25772 18.7596C2.89242 18.4029 2.61306 17.9731 2.43677 17.4961C2.28635 17.1094 2.10589 16.5248 2.05874 15.4547C2.007 14.2943 1.99428 13.9461 1.99428 11.0107C1.99428 8.07535 2.007 7.72298 2.05874 6.56698C2.10589 5.49254 2.28635 4.91235 2.43677 4.52555C2.61306 4.04842 2.89241 3.61439 3.26211 3.26189C3.61865 2.89658 4.04842 2.61723 4.52555 2.44115C4.91235 2.29073 5.49692 2.11023 6.56697 2.06291C7.72736 2.01134 8.07556 1.99844 11.0107 1.99844C13.9505 1.99844 14.2985 2.01134 15.4547 2.06291C16.5292 2.11027 17.1093 2.29069 17.4961 2.44111C17.9731 2.61723 18.4072 2.89658 18.7596 3.26189C19.1249 3.61865 19.4042 4.04842 19.5805 4.52555C19.731 4.91235 19.9114 5.49671 19.9587 6.56698C20.0103 7.72736 20.0232 8.07535 20.0232 11.0107C20.0232 13.9461 20.0104 14.29 19.9588 15.4503Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
                <path
                    d="M11.0026 5.35054C7.88252 5.35054 5.35107 7.88182 5.35107 11.0021C5.35107 14.1223 7.88252 16.6536 11.0026 16.6536C14.1227 16.6536 16.6541 14.1223 16.6541 11.0021C16.6541 7.88182 14.1227 5.35054 11.0026 5.35054ZM11.0026 14.668C8.97844 14.668 7.33654 13.0264 7.33654 11.0021C7.33654 8.97774 8.97844 7.33609 11.0025 7.33609C13.0269 7.33609 14.6685 8.97774 14.6685 11.0021C14.6685 13.0264 13.0268 14.668 11.0026 14.668ZM18.1971 5.12706C18.1971 5.85569 17.6063 6.44646 16.8775 6.44646C16.1489 6.44646 15.5581 5.85569 15.5581 5.12706C15.5581 4.39833 16.1489 3.80774 16.8775 3.80774C17.6063 3.80774 18.1971 4.39829 18.1971 5.12706Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
                </svg>
            </div>
            </button>
        `,
		media: `
            <svg
                fill="none"
                viewBox="0 0 22 22"
                height="22"
                width="22"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M21.94 6.46809C21.8884 5.2991 21.6994 4.49551 21.4285 3.79911C21.1492 3.05994 20.7194 2.39818 20.1564 1.84802C19.6062 1.28932 18.9401 0.855163 18.2094 0.580194C17.5091 0.309437 16.7096 0.120336 15.5407 0.0688497C14.363 0.0128932 13.9891 0 11.0022 0C8.01527 0 7.64141 0.0128932 6.46808 0.064466C5.29914 0.116039 4.49551 0.305225 3.79932 0.57581C3.05994 0.855163 2.39818 1.28494 1.84802 1.84802C1.28932 2.39813 0.855377 3.06428 0.580193 3.7949C0.309437 4.49551 0.120379 5.2948 0.0688496 6.4637C0.0129362 7.64141 0 8.01527 0 11.0022C0 13.9891 0.0129362 14.363 0.0644659 15.5363C0.116039 16.7053 0.305225 17.5089 0.576025 18.2053C0.855377 18.9444 1.28932 19.6062 1.84802 20.1564C2.39818 20.7151 3.06432 21.1492 3.79494 21.4242C4.49547 21.6949 5.29476 21.884 6.46391 21.9355C7.63702 21.9873 8.0111 22 10.998 22C13.9849 22 14.3588 21.9873 15.5321 21.9355C16.7011 21.884 17.5047 21.695 18.2009 21.4242C18.9321 21.1415 19.5961 20.7091 20.1505 20.1548C20.7048 19.6005 21.1373 18.9365 21.42 18.2053C21.6906 17.5047 21.8798 16.7052 21.9314 15.5363C21.9829 14.363 21.9958 13.9891 21.9958 11.0022C21.9958 8.01527 21.9914 7.64137 21.94 6.46809ZM19.9588 15.4503C19.9114 16.5248 19.731 17.105 19.5805 17.4918C19.2109 18.4502 18.4502 19.2109 17.4918 19.5805C17.105 19.731 16.5206 19.9114 15.4503 19.9586C14.29 20.0103 13.942 20.023 11.0066 20.023C8.07118 20.023 7.71881 20.0103 6.56259 19.9586C5.48816 19.9114 4.90796 19.731 4.52117 19.5805C4.04425 19.4043 3.61014 19.1249 3.25772 18.7596C2.89242 18.4029 2.61306 17.9731 2.43677 17.4961C2.28635 17.1094 2.10589 16.5248 2.05874 15.4547C2.007 14.2943 1.99428 13.9461 1.99428 11.0107C1.99428 8.07535 2.007 7.72298 2.05874 6.56698C2.10589 5.49254 2.28635 4.91235 2.43677 4.52555C2.61306 4.04842 2.89241 3.61439 3.26211 3.26189C3.61865 2.89658 4.04842 2.61723 4.52555 2.44115C4.91235 2.29073 5.49692 2.11023 6.56697 2.06291C7.72736 2.01134 8.07556 1.99844 11.0107 1.99844C13.9505 1.99844 14.2985 2.01134 15.4547 2.06291C16.5292 2.11027 17.1093 2.29069 17.4961 2.44111C17.9731 2.61723 18.4072 2.89658 18.7596 3.26189C19.1249 3.61865 19.4042 4.04842 19.5805 4.52555C19.731 4.91235 19.9114 5.49671 19.9587 6.56698C20.0103 7.72736 20.0232 8.07535 20.0232 11.0107C20.0232 13.9461 20.0104 14.29 19.9588 15.4503Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
                <path
                    d="M11.0026 5.35054C7.88252 5.35054 5.35107 7.88182 5.35107 11.0021C5.35107 14.1223 7.88252 16.6536 11.0026 16.6536C14.1227 16.6536 16.6541 14.1223 16.6541 11.0021C16.6541 7.88182 14.1227 5.35054 11.0026 5.35054ZM11.0026 14.668C8.97844 14.668 7.33654 13.0264 7.33654 11.0021C7.33654 8.97774 8.97844 7.33609 11.0025 7.33609C13.0269 7.33609 14.6685 8.97774 14.6685 11.0021C14.6685 13.0264 13.0268 14.668 11.0026 14.668ZM18.1971 5.12706C18.1971 5.85569 17.6063 6.44646 16.8775 6.44646C16.1489 6.44646 15.5581 5.85569 15.5581 5.12706C15.5581 4.39833 16.1489 3.80774 16.8775 3.80774C17.6063 3.80774 18.1971 4.39829 18.1971 5.12706Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
                </svg>
        `,
	},
	{
		name: "X",
		key: "x-button",
		content: `
            <button class="relative inline-block w-12 h-12 rounded-full group">
            <div
                class="floater w-full h-full absolute top-0 left-0 bg-black rounded-full duration-300 group-hover:-top-8 group-hover:shadow-2xl"
            ></div>
            <div
                class="icon relative z-10 w-full h-full flex items-center justify-center border-2 border-black rounded-full"
            >
                <svg
                fill="none"
                viewBox="0 0 22 22"
                height="22"
                width="22"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M12.8115 9.3155L20.8253 0H18.9263L11.9679 8.08852L6.41015 0H0L8.40433 12.2313L0 22H1.89914L9.24745 13.4583L15.1168 22H21.5269L12.811 9.3155H12.8115ZM10.2103 12.339L9.35878 11.1211L2.58343 1.42964H5.5004L10.9682 9.25094L11.8197 10.4689L18.9272 20.6354H16.0102L10.2103 12.3395V12.339Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
                </svg>
            </div>
            </button>
        `,
		media: `
            <svg
                fill="none"
                viewBox="0 0 22 22"
                height="22"
                width="22"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M12.8115 9.3155L20.8253 0H18.9263L11.9679 8.08852L6.41015 0H0L8.40433 12.2313L0 22H1.89914L9.24745 13.4583L15.1168 22H21.5269L12.811 9.3155H12.8115ZM10.2103 12.339L9.35878 11.1211L2.58343 1.42964H5.5004L10.9682 9.25094L11.8197 10.4689L18.9272 20.6354H16.0102L10.2103 12.3395V12.339Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
            </svg>
        `,
	},
	{
		name: "Facebook",
		key: "facebook-button",
		content: `
            <button class="relative inline-block w-12 h-12 rounded-full group">
            <div
                class="floater w-full h-full absolute top-0 left-0 bg-blue-500 rounded-full duration-300 group-hover:-top-8 group-hover:shadow-2xl"
            ></div>
            <div
                class="icon relative z-10 w-full h-full flex items-center justify-center border-2 border-blue-500 rounded-full"
            >
                <svg
                fill="none"
                viewBox="0 0 13 22"
                height="22"
                width="13"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M7.71289 22H4.1898C3.60134 22 3.12262 21.5213 3.12262 20.9328V12.9863H1.06717C0.478672 12.9863 0 12.5074 0 11.9191V8.514C0 7.9255 0.478672 7.44683 1.06717 7.44683H3.12262V5.74166C3.12262 4.05092 3.6535 2.6125 4.65773 1.58207C5.6665 0.546992 7.07627 0 8.7346 0L11.4214 0.00438281C12.0089 0.00537109 12.4868 0.484086 12.4868 1.07151V4.23311C12.4868 4.82157 12.0083 5.30028 11.4199 5.30028L9.61091 5.30093C9.05919 5.30093 8.91868 5.41153 8.88864 5.44543C8.83914 5.50172 8.78023 5.66062 8.78023 6.09954V7.4467H11.284C11.4725 7.4467 11.6551 7.49319 11.812 7.58076C12.1506 7.76995 12.3611 8.12762 12.3611 8.51417L12.3597 11.9193C12.3597 12.5074 11.881 12.9861 11.2926 12.9861H8.78019V20.9328C8.78023 21.5213 8.30139 22 7.71289 22ZM4.41233 20.7103H7.49031V12.4089C7.49031 12.016 7.81009 11.6964 8.20282 11.6964H11.07L11.0712 8.73662H8.20265C7.80991 8.73662 7.49031 8.41706 7.49031 8.02411V6.09959C7.49031 5.59573 7.54153 5.0227 7.92185 4.59198C8.38144 4.07133 9.10568 4.01126 9.61056 4.01126L11.1971 4.01057V1.29375L8.73357 1.28975C6.06848 1.28975 4.41238 2.99574 4.41238 5.7417V8.02407C4.41238 8.4168 4.09277 8.73658 3.7 8.73658H1.28975V11.6964H3.7C4.09277 11.6964 4.41238 12.016 4.41238 12.4089L4.41233 20.7103Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
                </svg>
            </div>
            </button>
        `,
		media: `
            <svg
                fill="none"
                viewBox="0 0 13 22"
                height="22"
                width="13"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M7.71289 22H4.1898C3.60134 22 3.12262 21.5213 3.12262 20.9328V12.9863H1.06717C0.478672 12.9863 0 12.5074 0 11.9191V8.514C0 7.9255 0.478672 7.44683 1.06717 7.44683H3.12262V5.74166C3.12262 4.05092 3.6535 2.6125 4.65773 1.58207C5.6665 0.546992 7.07627 0 8.7346 0L11.4214 0.00438281C12.0089 0.00537109 12.4868 0.484086 12.4868 1.07151V4.23311C12.4868 4.82157 12.0083 5.30028 11.4199 5.30028L9.61091 5.30093C9.05919 5.30093 8.91868 5.41153 8.88864 5.44543C8.83914 5.50172 8.78023 5.66062 8.78023 6.09954V7.4467H11.284C11.4725 7.4467 11.6551 7.49319 11.812 7.58076C12.1506 7.76995 12.3611 8.12762 12.3611 8.51417L12.3597 11.9193C12.3597 12.5074 11.881 12.9861 11.2926 12.9861H8.78019V20.9328C8.78023 21.5213 8.30139 22 7.71289 22ZM4.41233 20.7103H7.49031V12.4089C7.49031 12.016 7.81009 11.6964 8.20282 11.6964H11.07L11.0712 8.73662H8.20265C7.80991 8.73662 7.49031 8.41706 7.49031 8.02411V6.09959C7.49031 5.59573 7.54153 5.0227 7.92185 4.59198C8.38144 4.07133 9.10568 4.01126 9.61056 4.01126L11.1971 4.01057V1.29375L8.73357 1.28975C6.06848 1.28975 4.41238 2.99574 4.41238 5.7417V8.02407C4.41238 8.4168 4.09277 8.73658 3.7 8.73658H1.28975V11.6964H3.7C4.09277 11.6964 4.41238 12.016 4.41238 12.4089L4.41233 20.7103Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
            </svg>
        `,
	},
	{
		name: "YouTube",
		key: "youtube-button",
		content: `
            <button class="relative inline-block w-12 h-12 rounded-full group">
            <div
                class="floater w-full h-full absolute top-0 left-0 bg-red-400 rounded-full duration-300 group-hover:-top-8 group-hover:shadow-2xl"
            ></div>
            <div
                class="icon relative z-10 w-full h-full flex items-center justify-center border-2 border-red-400 rounded-full"
            >
                <svg
                fill="none"
                viewBox="0 0 30 22"
                height="22"
                width="30"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M18.9945 9.70081L12.5775 6.18974C12.2085 5.98783 11.7724 5.99538 11.4108 6.20965C11.0489 6.42415 10.833 6.80311 10.833 7.22372V14.1857C10.833 14.6043 11.0476 14.9826 11.407 15.1973C11.5947 15.3094 11.8028 15.3657 12.0113 15.3657C12.2064 15.3654 12.3984 15.3166 12.57 15.2237L18.9872 11.7731C19.1742 11.6726 19.3305 11.5235 19.4397 11.3415C19.5489 11.1596 19.6069 10.9515 19.6077 10.7393C19.6086 10.527 19.552 10.3184 19.4441 10.1356C19.3362 9.95283 19.1808 9.80259 18.9945 9.70081ZM12.5352 13.3099V8.10662L17.3312 10.7308L12.5352 13.3099Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
                <path
                    d="M28.8325 5.19239L28.8312 5.17912C28.8065 4.94533 28.5617 2.86581 27.5508 1.80806C26.3822 0.56396 25.0574 0.412829 24.4203 0.340384C24.3722 0.335071 24.3241 0.329304 24.276 0.323081L24.2253 0.317805C20.3854 0.0385769 14.5862 0.000453846 14.5282 0.000226923L14.5231 0L14.518 0.000226923C14.4599 0.000453846 8.66074 0.0385769 4.7862 0.317805L4.73503 0.323081C4.69379 0.328641 4.64834 0.333747 4.59893 0.339533C3.96916 0.412149 2.65857 0.563563 1.48674 1.8526C0.523851 2.89905 0.245531 4.93404 0.216938 5.16272L0.213648 5.19239C0.204968 5.28969 0 7.60572 0 9.93077V12.1042C0 14.4293 0.204968 16.7453 0.213648 16.8428L0.21518 16.8574C0.239801 17.0875 0.484424 19.1289 1.49071 20.1871C2.58947 21.3895 3.97869 21.5486 4.72595 21.6341C4.84407 21.6476 4.94578 21.6592 5.01511 21.6714L5.08228 21.6807C7.29943 21.8916 14.2509 21.9955 14.5456 21.9998L14.5545 22L14.5634 21.9998C14.6214 21.9995 20.4204 21.9614 24.2604 21.6822L24.3111 21.6769C24.3597 21.6705 24.4142 21.6647 24.474 21.6585C25.1003 21.592 26.4037 21.454 27.5594 20.1823C28.5223 19.1358 28.8008 17.1007 28.8292 16.8723L28.8325 16.8426C28.8412 16.7451 29.0464 14.4293 29.0464 12.1042V9.93077C29.0461 7.60566 28.8412 5.28991 28.8325 5.19239ZM27.344 12.1042C27.344 14.2563 27.1561 16.4725 27.1383 16.6759C27.0661 17.2364 26.7724 18.5239 26.3033 19.0338C25.58 19.8296 24.837 19.9085 24.2945 19.9659C24.234 19.9721 24.1736 19.9789 24.1132 19.9863C20.3991 20.2549 14.8189 20.296 14.5619 20.2976C14.2736 20.2934 7.42372 20.1886 5.2742 19.989C5.16403 19.971 5.04501 19.9572 4.91963 19.9431C4.2834 19.8702 3.41247 19.7704 2.74282 19.0338L2.72705 19.017C2.26611 18.5368 1.98092 17.3328 1.90842 16.6826C1.89492 16.5288 1.70215 14.2864 1.70215 12.1042V9.93077C1.70215 7.78124 1.88964 5.56738 1.9078 5.35975C1.99403 4.69957 2.29317 3.49007 2.74282 3.00117C3.48826 2.18124 4.27432 2.09041 4.7942 2.03034C4.84384 2.02455 4.89013 2.01927 4.93291 2.01371C8.70107 1.74379 14.3214 1.70368 14.5231 1.70215C14.7247 1.70345 20.3431 1.74379 24.0778 2.01371C24.1236 2.0195 24.1737 2.02523 24.2275 2.03147C24.7623 2.0924 25.5705 2.18459 26.3122 2.9757L26.319 2.98301C26.78 3.46324 27.0652 4.68828 27.1376 5.35152C27.1505 5.4967 27.344 7.74397 27.344 9.93077V12.1042Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
                </svg>
            </div>
            </button>
        `,
		media: `
            <svg
                fill="none"
                viewBox="0 0 30 22"
                height="22"
                width="30"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M18.9945 9.70081L12.5775 6.18974C12.2085 5.98783 11.7724 5.99538 11.4108 6.20965C11.0489 6.42415 10.833 6.80311 10.833 7.22372V14.1857C10.833 14.6043 11.0476 14.9826 11.407 15.1973C11.5947 15.3094 11.8028 15.3657 12.0113 15.3657C12.2064 15.3654 12.3984 15.3166 12.57 15.2237L18.9872 11.7731C19.1742 11.6726 19.3305 11.5235 19.4397 11.3415C19.5489 11.1596 19.6069 10.9515 19.6077 10.7393C19.6086 10.527 19.552 10.3184 19.4441 10.1356C19.3362 9.95283 19.1808 9.80259 18.9945 9.70081ZM12.5352 13.3099V8.10662L17.3312 10.7308L12.5352 13.3099Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
                <path
                    d="M28.8325 5.19239L28.8312 5.17912C28.8065 4.94533 28.5617 2.86581 27.5508 1.80806C26.3822 0.56396 25.0574 0.412829 24.4203 0.340384C24.3722 0.335071 24.3241 0.329304 24.276 0.323081L24.2253 0.317805C20.3854 0.0385769 14.5862 0.000453846 14.5282 0.000226923L14.5231 0L14.518 0.000226923C14.4599 0.000453846 8.66074 0.0385769 4.7862 0.317805L4.73503 0.323081C4.69379 0.328641 4.64834 0.333747 4.59893 0.339533C3.96916 0.412149 2.65857 0.563563 1.48674 1.8526C0.523851 2.89905 0.245531 4.93404 0.216938 5.16272L0.213648 5.19239C0.204968 5.28969 0 7.60572 0 9.93077V12.1042C0 14.4293 0.204968 16.7453 0.213648 16.8428L0.21518 16.8574C0.239801 17.0875 0.484424 19.1289 1.49071 20.1871C2.58947 21.3895 3.97869 21.5486 4.72595 21.6341C4.84407 21.6476 4.94578 21.6592 5.01511 21.6714L5.08228 21.6807C7.29943 21.8916 14.2509 21.9955 14.5456 21.9998L14.5545 22L14.5634 21.9998C14.6214 21.9995 20.4204 21.9614 24.2604 21.6822L24.3111 21.6769C24.3597 21.6705 24.4142 21.6647 24.474 21.6585C25.1003 21.592 26.4037 21.454 27.5594 20.1823C28.5223 19.1358 28.8008 17.1007 28.8292 16.8723L28.8325 16.8426C28.8412 16.7451 29.0464 14.4293 29.0464 12.1042V9.93077C29.0461 7.60566 28.8412 5.28991 28.8325 5.19239ZM27.344 12.1042C27.344 14.2563 27.1561 16.4725 27.1383 16.6759C27.0661 17.2364 26.7724 18.5239 26.3033 19.0338C25.58 19.8296 24.837 19.9085 24.2945 19.9659C24.234 19.9721 24.1736 19.9789 24.1132 19.9863C20.3991 20.2549 14.8189 20.296 14.5619 20.2976C14.2736 20.2934 7.42372 20.1886 5.2742 19.989C5.16403 19.971 5.04501 19.9572 4.91963 19.9431C4.2834 19.8702 3.41247 19.7704 2.74282 19.0338L2.72705 19.017C2.26611 18.5368 1.98092 17.3328 1.90842 16.6826C1.89492 16.5288 1.70215 14.2864 1.70215 12.1042V9.93077C1.70215 7.78124 1.88964 5.56738 1.9078 5.35975C1.99403 4.69957 2.29317 3.49007 2.74282 3.00117C3.48826 2.18124 4.27432 2.09041 4.7942 2.03034C4.84384 2.02455 4.89013 2.01927 4.93291 2.01371C8.70107 1.74379 14.3214 1.70368 14.5231 1.70215C14.7247 1.70345 20.3431 1.74379 24.0778 2.01371C24.1236 2.0195 24.1737 2.02523 24.2275 2.03147C24.7623 2.0924 25.5705 2.18459 26.3122 2.9757L26.319 2.98301C26.78 3.46324 27.0652 4.68828 27.1376 5.35152C27.1505 5.4967 27.344 7.74397 27.344 9.93077V12.1042Z"
                    class="group-hover:fill-[#171543] fill-white duration-300"
                ></path>
            </svg>
        `,
	},
];
